<template>
    <div class="page-cabinet-verification-profile-juridical">
        <ui-form
            v-bind:model="fields"
            v-bind:validation="$v"
            v-bind:submit-handler="submit"
            v-on:update="updateFormData"
            gap="wide"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import forms from '~/forms';
import moment from 'moment';

const isScreenLarge = () => window.innerWidth >= 768;
export default {
    name: 'page-cabinet-verification-profile-juridical',
    props: {
        isTouched: {
            type: Boolean,
        },
    },
    data: () => ({
        isLargeScreen: isScreenLarge(),
        observer: null,
    }),
    validations() {
        const result = {
            fields: {
                inn: { ...forms.validations.inn10 },
                ogrn: { ...forms.validations.ogrn },
                kpp: { ...forms.validations.kpp },
                organizationName: { ...forms.validations.genericRequired },
                organizationAddress: { ...forms.validations.genericRequired },
                organizationRegistrationAddress: { ...forms.validations.genericRequired },
                organizationPostalAddress: { ...forms.validations.genericRequired },
                // organizationNameFull: { ...forms.validations.genericRequired },
                // bankName: { ...forms.validations.genericRequired },
                // okved: { ...forms.validations.genericRequired },
                // bik: { ...forms.validations.bik },
                // corrAccount: { ...forms.validations.genericRequired },
                // organisationRegistrationDate: { ...forms.validations.date },
            },
        };
        return result;
    },
    computed: {
        ...mapState('verification/profile', [
            'juridical',
            'general',
        ]),
        fields() {
            const result = {
                inn: { ...forms.fields.inn10dadata },
                organizationName: { ...forms.fields.user.juridical.juridicalName },
                ogrn: { ...forms.fields.ogrn },
                kpp: { ...forms.fields.user.juridical.juridicalKpp },
                organizationAddress: { ...forms.fields.user.juridical.juridicalAddress },
                organizationRegistrationAddress: { ...forms.fields.user.juridical.juridicalRegistrationAddress },
                organizationPostalAddress: { ...forms.fields.user.juridical.juridicalPostalAddress },
                // organizationNameFull: { ...forms.fields.user.juridical.juridicalNameFull },
                // bankName: { ...forms.fields.user.juridical.juridicalBankName },
                // okved: { ...forms.fields.user.juridical.juridicalOkved },
                // bik: { ...forms.fields.user.juridical.juridicalBik },
                // corrAccount: { ...forms.fields.user.juridical.juridicalCorrAccount },
                // organisationRegistrationDate: { ...forms.fields.user.juridical.juridicalRegistrationDate },
            };
            if (this.isLargeScreen) {
                result.inn.isHalf = true;
                result.organizationName.isHalf = true;
                result.ogrn.isHalf = true;
                result.kpp.isHalf = true;
                result.organizationAddress.isHalf = true;
                result.organizationRegistrationAddress.isHalf = true;
                result.organizationPostalAddress.isHalf = true;
                // result.okved.isHalf = true;
                // result.bik.isHalf = true;
                // result.corrAccount.isHalf = true;
                // result.organisationRegistrationDate.isHalf = true;
            }
            Object.keys(result).forEach(key => {
                if (key === 'inn') {
                    result[key].value = this.general[key] === null ? '' : this.general[key];
                } else {
                    result[key].value = this.juridical[key] === null ? '' : this.juridical[key];
                }
            });
            return result;
        },
    },
    methods: {
        submit() {
            if (this.$v.$invalid) {
                this.$v.$touch();
                return;
            }
            this.$emit('submit');
        },
        updateFormData(newData) {
            const result = {};
            const resultGeneral = {};
            Object.keys(newData).filter(x => x !== 'inn').forEach(key => {
                result[key] = newData[key].value === '' ? null : newData[key].value;
            });
            if (typeof newData.inn?.value === 'object') {
                const data = newData.inn.value.data;
                resultGeneral.inn = data.inn;
                if (
                    data.management?.name &&
                    data.management?.post?.toLowerCase() === 'генеральный директор'
                ) {
                    const [ lastName, firstName, secondName ] = data.management.name.split(' ');
                    if (firstName) {
                        resultGeneral.firstName = firstName;
                    }
                    if (lastName) {
                        resultGeneral.lastName = lastName;
                    }
                    if (secondName) {
                        resultGeneral.secondName = secondName;
                    }
                }
                if (data.ogrn) {
                    result.ogrn = data.ogrn;
                }
                if (data.okved) {
                    result.okved = data.okved;
                }
                if (data.kpp) {
                    result.kpp = data.kpp;
                }
                // eslint-disable-next-line camelcase
                if (data.name?.short_with_opf) {
                    // eslint-disable-next-line camelcase
                    result.organizationName = data.name.short_with_opf;
                }
                // eslint-disable-next-line camelcase
                if (data.name?.full_with_opf) {
                    // eslint-disable-next-line camelcase
                    result.organizationNameFull = data.name.full_with_opf;
                }
                // eslint-disable-next-line camelcase
                if (data.address?.unrestricted_value) {
                    // eslint-disable-next-line camelcase
                    result.organizationAddress = data.address.unrestricted_value;
                    result.organizationRegistrationAddress = data.address.unrestricted_value;
                    result.organizationPostalAddress = data.address.unrestricted_value;
                }
                // eslint-disable-next-line camelcase
                if (data.state?.registration_date) {
                    // eslint-disable-next-line camelcase
                    result.organisationRegistrationDate = moment(data.state?.registration_date).format('DD.MM.YYYY');
                }
            } else {
                resultGeneral.inn = newData.inn.value;
            }
            if (Object.keys(resultGeneral).length > 0) {
                this.$store.state.verification.profile.general = {
                    ...this.$store.state.verification.profile.general,
                    ...resultGeneral,
                };
            }
            this.$store.state.verification.profile.juridical = {
                ...this.$store.state.verification.profile.juridical,
                ...result,
            };
        },
    },
    mounted() {
        this.observer = new ResizeObserver(() => {
            this.isLargeScreen = isScreenLarge();
        });
        this.observer.observe(document.body);
    },
    beforeDestroy() {
        this.observer.disconnect();
    },
    watch: {
        isTouched: {
            handler(newVal) {
                if (newVal) {
                    this.$v.$touch();
                }
            },
            immediate: true,
        },
        '$v.$dirty': {
            handler(newVal) {
                if (newVal) {
                    this.$emit('touch');
                }
            },
            immediate: true,
        },
        '$v.$invalid': {
            handler(newVal) {
                this.$emit('validation-update', { entityName: 'isJuridicalDataValid', value: !newVal });
            },
            immediate: true,
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-verification-profile-juridical {
}
</style>
